export const experience = [
    // {
    //     id: 'directfn',
    //     company: 'DirectFN',
    //     role: 'Tech Lead / Software Engineer',
    //     tab: 'DirectFN',
    //     location: 'Malabe, Sri Lanka',
    //     workStart: 'Jul 2022',
    //     workUntil: 'Present',
    //     period: 'Jul 2022 — Present',
    //     url: 'https://www.directfn.com/',
    //     current: true,
    //     summary:
    //         'Progressed from Software Engineer to Tech Lead while delivering enterprise fintech applications and client-specific solutions with C#/.NET and Oracle PL/SQL.',
    //     responsibilities: [
    //         'Develop and maintain application components using C#/.NET and complex Oracle PL/SQL structures for reliable, scalable business workflows',
    //         'Work in Scrum-based delivery with Jira and formal SDLC practices, including onsite client collaboration',
    //         'Researched code obfuscation and security upgrades, and built project-build tooling and internal utilities to improve engineering efficiency',
    //     ],
    //     technologies: ['C# / .NET', 'Oracle PL/SQL', 'Fintech'],
    //     projects: [],
    // },
    {
        id: 'projectxspace',
        company: 'ProjectXSpace',
        role: 'Full Stack Developer',
        tab: 'ProjectXSpace',
        location: 'Rosanna, Victoria, Australia (Remote)',
        workStart: 'Aug 2020',
        workUntil: 'Apr 2022',
        period: 'Aug 2020 — Apr 2022',
        url: 'http://www.projectxspace.com/',
        current: false,
        summary:
            'Delivered e-commerce, vehicle-routing and recommendation products across Angular, TypeScript, .NET, Python, SQL Server, Azure Service Bus and Google APIs.',
        responsibilities: [
            'Worked on frontend, backend and machine learning development',
            'Engineered applications with .NET, Angular, TypeScript, Akita, Python, SQL Server and web services (REST, Azure Service Bus, Google APIs)',
            'Deployed and integrated software, and updated integration/deployment scripts to improve continuous integration practices',
        ],
        technologies: ['Angular', 'TypeScript', '.NET', 'Python', 'SQL Server', 'Azure Service Bus', 'Google APIs'],
        projects: [
            {
                name: 'Brazen brownies',
                detail: 'E-commerce web application and POS system',
                technologies: ['Angular', '.NET', 'SQL Server'],
            },
            {
                name: 'Delivery Route Engine',
                detail: 'Cost-effective engine for vehicle routing optimization',
                technologies: ['Python', 'Google Maps APIs', 'Azure Service Bus'],
            },
            {
                name: 'Recommendation system',
                detail: 'Product recommendations based on user behaviour and preference',
                technologies: ['Python', 'Pandas', 'Sklearn', 'matplotlib'],
            },
        ],
    },
    {
        id: 'bevylabs',
        company: 'BevyLabs',
        role: 'Software Engineer',
        tab: 'BevyLabs',
        location: 'Katugastota, Sri Lanka',
        workStart: 'Mar 2020',
        workUntil: 'Sep 2020',
        period: 'Mar 2020 — Sep 2020',
        url: 'https://bevylabs.org/',
        current: false,
        summary:
            'Built web and mobile products including the ALTER GEN QR-payment hardware solution and a computer-vision shrimp counter proof of concept.',
        responsibilities: [
            'Developed web and mobile solutions using PHP, JavaScript, Angular, Vue.js, Android and Firebase',
            'Built ALTER GEN, a QR-payment hardware solution, using C++, Android and Firebase',
        ],
        technologies: ['Vue.js', 'Angular', 'PHP', 'JavaScript', 'Android', 'C++', 'OpenCV.js', 'Firebase'],
        projects: [
            {
                name: 'ALTER GEN',
                detail: 'QR-payment hardware solution',
                technologies: ['C++', 'Android', 'Firebase'],
            },
            {
                name: 'Shrimp Counter App',
                detail: 'Computer-vision proof of concept to count shrimp',
                technologies: ['Vue.js', 'OpenCV.js', 'Firebase'],
            },
            {
                name: 'Doctona-Mr App',
                detail: 'Healthcare app connecting doctors and patients',
                technologies: ['React Native', 'Android', 'Agora.io', 'Firebase'],
            },
        ],
    },
    {
        id: 'mobitel',
        company: 'Mobitel',
        role: 'Software Engineer Intern',
        tab: 'Mobitel',
        location: 'Mobitel (Pvt) Limited, Engineering Division, Colombo, Sri Lanka',
        workStart: 'Sep 2019',
        workUntil: 'Feb 2020',
        period: 'Sep 2019 — Feb 2020',
        url: 'https://www.mobitel.lk/',
        current: false,
        summary:
            'Started my professional journey building internal web applications and a generator fuel-monitoring solution for engineering operations.',
        responsibilities: [
            'Front-end development with HTML, CSS and JavaScript, and back-end development with PHP and MySQL',
            'Helped with end-user support for stakeholders by preparing user manuals',
            'Built internal web applications and a generator fuel-monitoring solution for engineering operations',
        ],
        technologies: ['PHP', 'MySQL', 'HTML', 'CSS', 'JavaScript', 'C++ / Android'],
        projects: [
            {
                name: 'New on-air sites tracker',
                detail: 'Tracked a site from definition through configuration to on-air',
                technologies: ['Laravel', 'Bootstrap', 'SCSS', 'jQuery'],
            },
            {
                name: 'Cell Block Manager',
                detail: 'Communicated block and deblock of site cells',
                technologies: ['PHP', 'Bootstrap', 'Sass', 'MySQL'],
            },
        ],
    },
];

export default experience;
